import * as React from 'react';
import styled from 'styled-components';
import { hasValue } from '../../lib/utils';
import { phoneOnlyMaxWidth } from '../cssConstants';

interface FormContentProps {
	maxWidth?: string;
}

export const FormContent = styled.section<FormContentProps>`
	width: 100%;
	max-width: ${({ maxWidth }) => maxWidth || '795px'};
	position: relative;
	margin: auto;
	height: fit-content;

	@media (max-width: 1145px) {
		width: 75%;
	}

	@media (max-width: 599px) {
		width: 90%;
		margin: auto;
	}
`;

// This Component assumes that the array containing its children will never change.
export const RowsWithHalfCells = (props: { children: JSX.Element[] }) => {
	const pairs: JSX.Element[][] = [];
	let currentPair: JSX.Element[] = [];
	props.children?.forEach((c) => {
		currentPair.push(c);
		const pairSize = 2;
		if (currentPair.length === pairSize) {
			pairs.push(currentPair);
			currentPair = [];
		}
	});

	if (currentPair.length > 0) {
		pairs.push(currentPair);
	}

	return (
		<>
			{pairs.map(([first, second], index) => (
				// eslint-disable-next-line react/no-array-index-key
				<Row key={index}>
					<HalfCell>{first}</HalfCell>
					{hasValue(second) ? <HalfCell>{second}</HalfCell> : null}
				</Row>
			))}
		</>
	);
};

export const Row = styled.div<{ top?: string }>`
	${(props) => (hasValue(props.top) ? `margin-top: ${props.top};` : `margin-top: 23px`)};
	${(props) => (hasValue(props.top) ? `margin-bottom: ${props.top};` : `margin-top: 23px`)};
	display: flex;

	/* On phones each field takes a full row of its own. */
	@media (max-width: ${phoneOnlyMaxWidth}) {
		flex-direction: column;
	}
`;

export const Cell = styled.div<{ width?: string; left?: string; right?: string }>`
	display: inline-block;
	${(props) => (hasValue(props.width) ? `width: ${props.width};` : '')}
	${(props) => (hasValue(props.left) ? `margin-left: ${props.left};` : 'margin-left: 11px;')}
	${(props) => (hasValue(props.right) ? `margin-right: ${props.right};` : 'margin-right: 11px;')}
	:first-child {
		${(props) => (hasValue(props.left) ? `margin-left: ${props.left};` : 'margin-left: 0px;')}
	}
	:last-child {
		${(props) => (hasValue(props.right) ? `margin-right: ${props.right};` : 'margin-right: 0px;')}
	}
`;

export const HalfCell = styled(Cell)`
	width: 50%;

	/* Stacked on phones, so each cell spans the full width and needs its own spacing. */
	@media (max-width: ${phoneOnlyMaxWidth}) {
		width: 100%;
		margin-left: 0;
		margin-right: 0;

		& + & {
			margin-top: 23px;
		}
	}
`;
